import { useEffect } from "react";
import { useTabStatus } from "@/hooks/useTabStatus";
import { setTabVisible } from "@/services/chatRunTracker";

export function TabStatusManager() {
  const tabVisible = useTabStatus();

  useEffect(() => {
    setTabVisible(tabVisible);
  }, [tabVisible]);

  return null;
}
